import React, { createContext, useContext, useState } from 'react';
import { translations } from './translations';

const LanguageContext = createContext({ lang: 'en', toggle: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(
    () => localStorage.getItem('heyday_lang') || 'en'
  );

  const toggle = () =>
    setLang(prev => {
      const next = prev === 'en' ? 'es' : 'en';
      localStorage.setItem('heyday_lang', next);
      return next;
    });

  return (
    <LanguageContext.Provider value={{ lang, toggle }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export const useT = () => {
  const { lang } = useLanguage();
  return (key) =>
    translations[lang]?.[key] ?? translations.en[key] ?? key;
};
